<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/aNl8U7/tc-custom/9781504098014.jpg?1728851738845" alt="This image is the cover for the book Come Home to Death, The Patrick Dawlish Mysteries"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Come Home to Death, The Patrick Dawlish Mysteries
      </h1>
      <p class="bookDescription body article font2">
        <b>Patrick Dawlish is used to solving crimes, not being suspected of them—until now, in this Golden Age British mystery from the Edgar Award–winning author.</b><br/><br/>Patrick Dawlish has to admire Marion Ard’s persistence. After first writing and telephoning, she shows up on his doorstep, begging for his help. Marion is convinced that a strange man has been following her for the last seven months. Tired of the police ignoring her pleas, she has turned to Dawlish as a last resort. But Dawlish and his wife are leaving on a much-needed holiday the following morning. All he can do is ask his friend Tim Jeremy to shadow her for the next few days. <br/><br/>Weeks into the cruise, Dawlish gets a letter from Tim. Not only was Marion being followed, but she’s disappeared. And then, her body is found—in a trunk in Dawlish’s home. Catching the next flight back, Dawlish finds himself in a position he’s never been in before—the prime suspect in a murder. With Tim missing, it becomes clear that someone has put into motion the perfect plan to take him down, but it’s never smart to count Dawlish out . . .
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        John Creasey
      </h2>
      
      <p class="authorDescription body article">John Creasey, born in 1908, was a paramount English crime and science fiction writer who used myriad pseudonyms for more than six hundred novels. He founded the UK Crime Writers&rsquo; Association in 1953. In 1962, his book <I>Gideon&rsquo;s Fire</I> received the Edgar Award for Best Novel from the Mystery Writers of America. Many of the characters featured in Creasey&rsquo;s titles became popular, including George Gideon of Scotland Yard, who was the basis for a subsequent television series and film. Creasey died in Salisbury, UK, in 1973.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?2de40f03